import FeatureContainer from './FeatureContainer';

export default FeatureContainer;
